<template>
  <div class="country--modal">
    <div class="country--header">
      <h1 style="font-family: Baller">{{ info.name }}</h1>
      <div class="select--containers">
        <div v-if="(clubs && clubs.length) || (players && players.length)" v-on:click="clearSelection" class="clear--all">
          Clear All
        </div>
        <div class="selection">
          <div class="club--select" v-if="clubs && clubs.length">
            <multiselect
              v-model="selectedClub"
              :options="clubs"
              :searchable="false"
              :close-on-select="false"
              :show-labels="false"
              track-by="name"
              label="name"
              placeholder="Clubs"
              @input="selectionChange"
            ></multiselect>
          </div>

          <div class="player--select" v-if="players && players.length">
            <multiselect
              v-model="selectedPlayer"
              :options="players"
              :searchable="false"
              :close-on-select="false"
              :show-labels="false"
              track-by="name"
              label="name"
              placeholder="Players"
              @input="selectionChange"
            ></multiselect>
          </div>
        </div>
      </div>
    </div>

    <ul @scroll="onScroll" v-if="links && links.length" class="list">
      <li v-for="(link, index) in links" :key="index">
        <youtube v-if="link.type === 'Youtube'" :link="link" />
        <div v-else>
          <span>{{ link.type }}</span>
          <span>{{ link.url }}</span>
          {{ link.title }}
        </div>
      </li>
    </ul>
    <span v-if="loading">Loading</span>
  </div>
</template>
<script>
import Youtube from "./Youtube";
import Multiselect from "vue-multiselect";
import { GET_LINKS, GET_CLUBS, GET_PLAYERS } from "../graphql";

const RESULTS_PER_PAGE = 12;
export default {
  props: {
    info: Object
  },
  name: "country",
  computed: {},
  components: {
    Multiselect,
    youtube: Youtube
  },
  methods: {
    onScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
      if (Math.round(scrollTop + clientHeight) + 1 >= scrollHeight) {
        if (this.pagination) {
          this.showMore();
        }
      }
    },
    linksFunc: function() {},
    async showMore() {
      this.loading = true;
      await this.$apollo.queries.links.fetchMore({
        variables: {
          country_name: this.info.name,
          start: this.links.length,
          limit: RESULTS_PER_PAGE,
          v: Math.random()
        },

        updateQuery: (previousResult, { fetchMoreResult }) => {
          this.loading = false;

          if (fetchMoreResult.links.length === 0) {
            this.pagination = false;
            return {
              links: [...previousResult.links],
              __typename: "Query"
            };
          }

          return {
            links: [...previousResult.links, ...fetchMoreResult.links],
            __typename: "Query"
          };
        }
      });
    },
    loadMore: function() {
      this.loading = true;
      this.offset = this.links ? this.links.length : 0;
      this.$apollo.queries.links.refresh();
    },
    toggleClubSelection: function() {
      this.clubSelectionVisible = !this.clubSelectionVisible;
    },
    togglePlayerSelection: function() {
      this.playerSelectionVisible = !this.playerSelectionVisible;
    },
    selectionChange: function() {
      this.links = [];
      this.pagination = false;
      this.$apollo.queries.links.refresh();
    },
    clearSelection: function() {
      this.links = [];
      this.pagination = true;
      this.offset = 0;
      this.selectedPlayer = undefined;
      this.selectedClub = undefined;
      this.$apollo.queries.links.refresh();
    },
    parse: function(additional) {
      this.loading = false;
      if (!additional.data.links || additional.data.links.length === 0) {
        this.pagination = false;
      }
    }
  },
  data() {
    return {
      offset: 0,
      loading: true,
      pagination: true,
      selectedClub: undefined,
      selectedPlayer: undefined,
      clubSelectionVisible: false,
      playerSelectionVisible: false
    };
  },
  apollo: {
    links: {
      query: GET_LINKS,
      // fetchPolicy: "no-cache",
      variables() {
        if (this.selectedPlayer && this.selectedPlayer.id !== undefined && this.selectedClub && this.selectedClub.id) {
          return {
            country_name: this.info.name,
            player_id: this.selectedPlayer.id,
            club_id: this.selectedClub.id
          };
        } else if (this.selectedPlayer && this.selectedPlayer.id !== undefined) {
          return {
            country_name: this.info.name,
            player_id: this.selectedPlayer.id
          };
        } else if (this.selectedClub && this.selectedClub.id !== undefined) {
          return {
            country_name: this.info.name,
            club_id: this.selectedClub.id
          };
        }

        return {
          country_name: this.info.name,
          start: this.offset,
          limit: RESULTS_PER_PAGE
        };
      },
      result: function(res) {
        this.parse(res);
      }
    },
    clubs: {
      query: GET_CLUBS,
      variables() {
        return {
          country_name: this.info.name
        };
      }
    },
    players: {
      query: GET_PLAYERS,
      variables() {
        return {
          country_name: this.info.name
        };
      }
    }
  }
};
</script>

<style lang="scss">
@import "../style/components/country";
// @import "../style/components/multiselect";
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
